import React from "react";
import { ThemeProvider } from "styled-components";

import HeaderTach from "./Header/HeaderTach";
import Filter from "./Filter/Filter";
import List from "./List/List";

import { AdministratorTachProvider } from "../../context/AdministratorTachContext";
import { FilterDataProvider } from "../../context/TachContext/FilterDataContext";

const AdministratorTach: React.FC = () => {
    return (
        <AdministratorTachProvider>
            <FilterDataProvider>
                <ThemeProvider theme={{}}>
                    <HeaderTach />
                    <Filter />
                    <List />
                </ThemeProvider>
            </FilterDataProvider>
        </AdministratorTachProvider>
    );
};

export default AdministratorTach;
